import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Checkbox from 'material-ui/Checkbox';

import Select from 'react-select';
import PeoplePicker from '../../PeoplePicker/PeoplePicker';
import CompanyPicker from '../../CompanyPicker/CompanyPicker';
import ProjectPicker from '../../ProjectPicker/ProjectPicker';
import ServiceKeyPicker from '../../ServiceKeyPicker/ServiceKeyPicker';
import FormTasks from '../../FormTasks/FormTasks';

import { communicationTypes } from '../../../models/Activity';
import SimplWysiwyg from '../../SimplWysiwyg/SimplWysiwyg';
import SimplDatepicker from '../../SimplDatepicker/SimplDatepicker';
import FormFileUpload from '../../FormFileUpload/FormFileUpload';
import { RaisedButton } from 'material-ui';

require('moment/locale/de');

const _ = require('lodash');

class Modal extends React.Component {
  componentWillReceiveProps(nextProps) {
    // form wasnt open but now is, for example after clicking "view all fields" on dashboard
    if (this.props.open === false && nextProps.open === true) {
      setTimeout(() => this.focus(), 150);
    }
  }

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  renderEndTime = () => {
    if (this.props.activity.end_date_manual === false) {
      return null;
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-sm-4">
          <label className="simpl-label" htmlFor="end_time_date_submit">
            Zeit bis
          </label>
        </div>
        <div className="col-xs-6 col-sm-3">
          <SimplDatepicker
            defaultValue={this.props.activity.end_time}
            onChange={date => {
              this.props.setState({
                end_time_date_submit: date,
                end_time: date,
              });
            }}
            minDate={this.props.activity.start_time}
          />
        </div>
        <div className="col-xs-6 col-sm-2">
          <input
            name="end_time_time_submit"
            value={this.props.activity.end_time_time_submit}
            onChange={e => this.props.handleChange(e)}
            onBlur={e => this.props.handleTimeChange(e)}
          />
        </div>
      </div>
    );
  };

  renderCommunicationDirection = () => {
    if (
      this.props.activity.communication_type === 'other' ||
      this.props.activity.communication_type === 'none'
    ) {
      return <div />;
    }

    return (
      <div className="col-xs-12 col-sm-8 off-sm-4">
        <RadioButtonGroup
          className="radiogroup radiogroup-horizontal radiogroup-horizontal-double"
          name="communication_direction"
          style={{ marginTop: 10, marginBottom: 20 }}
          onChange={e => this.props.handleChange(e)}
          defaultSelected={this.props.activity.communication_direction}
        >
          <RadioButton
            value="in"
            label={this.props.activity.commIn}
            style={{ display: 'flex' }}
          />
          <RadioButton
            value="out"
            label={this.props.activity.commOut}
            style={{ display: 'flex' }}
          />
        </RadioButtonGroup>
      </div>
    );
  };

  render() {
    const props = this.props;

    const opened = typeof props.open !== 'undefined' ? props.open : false;

    let buttonText = 'Erstellen';
    if (this.props.activity.id !== null) {
      buttonText = 'Speichern';
    }

    let title = 'Neue Aktivität erstellen';
    if (this.props.activity.id !== null) {
      title = `"${this.props.activity.title}" bearbeiten`;
    } else if (this.props.activity.title.length) {
      title = `"${this.props.activity.title}" erstellen`;
    }

    let syncText = 'Noch nicht gespeichert.';

    if (this.props.activity.lastSync !== null) {
      syncText = `${this.props.activity.lastSync.fromNow()} gespeichert`;
    }

    const actions = [
      <div
        className="sync"
        title="Einige Daten werden automatisch zwischengespeichert, um Datenverlust zu meiden. Davon ausgenommen: Teilnehmer, Aufgaben und beteiligte Unternehmen."
      >
        {syncText}
      </div>,
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          if (this.syncTimer !== null) {
            clearTimeout(this.syncTimer);
          }
          this.props.resetState();
          this.props.closeActivityForm();
        }}
      />,
      <RaisedButton
        style={{ marginLeft: 10 }}
        label={buttonText}
        primary
        disabled={this.props.activity.title.trim().length === 0}
        onMouseDown={() => this.props.save()}
      />,
    ];

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open={opened}
        autoScrollBodyContent
        className="form modal-center"
        contentClassName="form-container form-container--activity"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body"
      >
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="title">
              Thema
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <input
              name="title"
              required
              onChange={e => this.props.handleChange(e)}
              value={this.props.activity.title}
              ref={input => {
                this.primaryInput = input;
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="notes">
              Notiz
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <SimplWysiwyg
              content={this.props.activity.notes}
              onUpdate={content => {
                this.props.handleChange({
                  target: {
                    name: 'notes',
                    value: content,
                  },
                });
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="communication_type">
              Art der Kommunikation
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <Select
              name="communication_type"
              value={this.props.activity.communication_type}
              options={communicationTypes}
              onChange={this.props.selectCommunicationType}
              placeholder="Kommunikationsart auswählen..."
              clearable={false}
            />
          </div>
          {this.renderCommunicationDirection()}
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Teilnehmer
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <PeoplePicker
              type="all"
              name="person_ids"
              multi
              value={
                this.props.activity.personsRaw !== null
                  ? this.props.activity.personsRaw
                  : this.props.activity.person_ids
              }
              onChange={e => this.props.personPicked(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="start-time">
              Zeit
            </label>
          </div>
          <div className="col-xs-6 col-sm-3">
            <SimplDatepicker
              defaultValue={this.props.activity.start_time}
              onChange={date => {
                if (
                  moment(this.props.activity.start_time).diff(
                    moment(date),
                    'days',
                  ) !== 0
                ) {
                  this.props.setState({
                    end_time_date_submit: date,
                    end_time: date,
                  });
                }

                this.props.setState({
                  start_time_date_submit: date,
                  start_time: date,
                });
              }}
            />
          </div>
          <div className="col-xs-6 col-sm-2">
            <input
              name="start_time_time_submit"
              value={this.props.activity.start_time_time_submit}
              onChange={e => this.props.handleChange(e)}
              onBlur={e => this.props.handleTimeChange(e)}
            />
          </div>
          <div className="col-xs-12 col-sm-3 flex-vcenter">
            <Checkbox
              label="Zeitraum ang."
              checked={this.props.activity.end_date_manual}
              onCheck={(e, checked) => {
                this.props.setState({ end_date_manual: checked });
              }}
            />
          </div>
        </div>
        {this.renderEndTime()}
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Leistungsart
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <ServiceKeyPicker
              name="service_type_id"
              clearable
              default={this.props.activity.service_type_id}
              onChange={e => this.props.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Zuständiger
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <PeoplePicker
              type="staff"
              name="responsible_user"
              clearable={false}
              fetch={false}
              value={this.props.activity.responsible_user}
              onChange={e => this.props.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Unternehmen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <CompanyPicker
              name="company_id"
              default={this.props.activity.company_id}
              onChange={e => this.props.handleChange(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Beteiligte Unternehmen
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <CompanyPicker
              name="companies"
              multi
              default={this.props.activity.companies}
              onChange={e => this.props.companiesPicked(e)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="responsible">
              Projekt
            </label>
          </div>
          <div className="col-xs-12 col-sm-8">
            <ProjectPicker
              name="project_id"
              default={this.props.activity.project_id}
              onChange={e => this.props.handleChange(e)}
            />
          </div>
        </div>

        <hr />

        <FormTasks
          tasks={this.props.activity.tasks}
          onUpdate={tasks =>
            this.props.setState({
              tasks,
            })
          }
        />

        <hr />

        <FormFileUpload
          files={this.props.activity.files}
          onUpdate={files =>
            this.props.handleChange({
              target: {
                name: 'files',
                value: files,
              },
            })
          }
        />
      </Dialog>
    );
  }
}

Modal.propTypes = {
  activity: PropTypes.object.isRequired,
  save: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  setState: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
  closeActivityForm: PropTypes.func.isRequired,

  handleChange: PropTypes.func.isRequired,
  handleTimeChange: PropTypes.func.isRequired,
  personPicked: PropTypes.func.isRequired,
  companiesPicked: PropTypes.func.isRequired,
  selectCommunicationType: PropTypes.func.isRequired,

  sidebar: PropTypes.bool,
  todayWidget: PropTypes.bool,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/FormActivity/Components/Modal.js